<template>
  <div class="default-modal">
    <el-dialog
      :model-value="showRejectTestPopup"
      width="60%"
      top="5%"
      style="height: 580px"
      @close="onClose"
    >
      <!-- Header -->
      <div class="dialog-header">
        <span class="header-part">Select Tests to Reject</span>
        <el-button
          size="medium"
          class="el-white"
          type="button"
          plain
          @click="onClose"
        >
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
        </el-button>
      </div>

      <!-- Panels -->
      <div class="popup-date pb-3">
        <div class="rejectedCases">
          <div v-if="groupedTests && Object.keys(groupedTests).length">
            <!-- First: ALL_TESTS and SEND_OUTS -->
            <template
              v-for="panelCode in ['ALL_TESTS', 'SEND_OUTS']"
              :key="panelCode"
            >
              <div v-if="groupedTests[panelCode]" class="panelBlock">
                <div class="categoryOnlyHeader">
                  <span class="panel-name">{{
                    groupedTests[panelCode].title
                  }}</span>
                </div>
                <div class="testNamesGridBlock">
                  <div
                    v-for="test in groupedTests[panelCode].tests"
                    :key="test._id"
                    class="testNames"
                  >
                    <el-checkbox
                      :checked="!!selectedTests[test._id]"
                      @change="
                        emitUpdateIndividualTest(
                          test._id,
                          $event,
                          groupedTests[panelCode].panel_id,
                          groupedTests[panelCode].case_type_code,
                          test.test_name,
                          test.test_code,
                          test.lab_order_code,
                          panelCode
                        )
                      "
                    >
                      <span class="test-name">{{ test.test_name }}</span>
                    </el-checkbox>
                  </div>
                </div>
              </div>
            </template>

            <!-- Then: Remaining Panels -->
            <div class="panelsGridWrapper">
              <template
                v-for="(panelData, panelCode) in groupedTests"
                :key="panelCode"
              >
                <div
                  v-if="panelCode !== 'ALL_TESTS' && panelCode !== 'SEND_OUTS'"
                  class="panelGridItem"
                >
                  <el-checkbox
                    :model-value="!!selectedPanels[panelCode]"
                    @change="emitSelectPanelTests(panelCode, $event)"
                  >
                    <span class="panel-name">{{
                      panelData.title
                    }}</span></el-checkbox
                  >
                </div>
              </template>
            </div>
          </div>
          <div v-else class="no-data-message">
            No tests available to reject.
          </div>
        </div>

        <!-- Rejection Reason Form -->
        <el-form ref="ruleForm" :model="formData">
          <el-form-item prop="selectedReasons">
            <label>Reasons for Rejection</label>
            <span class="star">*</span>
            <el-select
              :model-value="formData.selectedReasons"
              placeholder="Choose reasons"
              multiple
              filterable
              allow-create
              collapse-tags
              default-first-option
              style="width: 100%"
              @change="emitUpdateReasons"
            >
              <el-option
                v-for="reason in predefinedReasons"
                :key="reason.value"
                :label="reason.label"
                :value="reason.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item prop="notes">
            <label>Additional Notes</label>
            <span class="star">*</span>
            <el-input
              type="textarea"
              rows="3"
              placeholder="Enter notes"
              :model-value="formData.notes"
              @input="emitUpdateNotes"
            />
            <p class="note-hint">
              <b>Note:</b> Minimum 3 characters are required
            </p>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="rejectCaseError" class="error-message">
        {{ rejectCaseError }}
      </div>

      <div class="testRejectedFooter">
        <el-button
          class="testRejectedBtn"
          type="danger"
          :disabled="isRejectButtonDisabled"
          v-loading="loading"
          @click="validateAndEmit"
        >
          Reject Selected Tests
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "TestsRejectPopup",
  props: {
    showRejectTestPopup: Boolean,
    groupedTests: Object,
    selectedTests: Object,
    selectedPanels: Object,
    formData: Object,
    loading: Boolean,
    rejectCaseError: String,
    isRejectButtonDisabled: Boolean,
    predefinedReasons: Array,
  },

  methods: {
    onClose() {
      this.$emit("close-popup");
    },
    emitUpdateIndividualTest(
      testId,
      isChecked,
      panelId,
      caseTypeCode,
      testName,
      testCode,
      labOrderCode,
      panelCode
    ) {
      this.$emit(
        "update-individual-test",
        testId,
        isChecked,
        panelId,
        caseTypeCode,
        testName,
        testCode,
        labOrderCode,
        panelCode
      );
    },
    emitSelectPanelTests(panelCode, isChecked) {
      this.$emit("select-panel-tests", panelCode, isChecked);
    },
    emitUpdateReasons(reasons) {
      const notesFromReasons = reasons.join(", ");
      this.$emit("update-reasons", reasons);
      this.$emit("update-notes", notesFromReasons); // auto-fill
    },
    emitUpdateNotes(notes) {
      this.$emit("update-notes", notes);
    },
    validateAndEmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("form-validated");
        }
      });
    },
  },
};
</script>

<style scoped>
.error-message {
  color: red;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
}

.panelBlock {
  margin-bottom: 1px;
  padding: 12px;
  border-bottom: 1px solid #e4e7ed;
}

.categoryOnlyHeader {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}

.panel-name {
  font-size: 14px;
  color: #273480;
  font-weight: 500;
}

.testNamesGridBlock {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.inline-panel {
  display: inline-block;
  margin-right: 50px;
  margin-bottom: 12px;
  margin-top: 10px;
  gap: 10px;
}

.panelsGridWrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px 24px;
  padding-left: 10px; /* Align with test checkboxes */
  margin-top: 16px;
}

.panelGridItem {
  display: flex;
  align-items: center;
}

.aligned-checkbox {
  display: inline-block;
  margin-right: 16px;
  margin-bottom: 12px;
  padding-left: 10px; /* 👈 Align panel checkboxes with test checkboxes */
}

.panel-name {
  font-size: 14px;
  color: #273480;
  grid-template-columns: repeat(3, 1fr);

  font-weight: 500;
}
.test-name {
  font-size: 13px;
  color: #333;
}
</style>
